




























































import { GtHeader, GtFooter, GtBannerAd, pageMixinCommon } from '@speedshop/template';
import { useHome } from '@speedshop/sdk-api';
import { isMobile } from '@/utils/platform.ts';
import defer from '@/mixins/defer';

export default {
  components: { GtFooter, GtHeader, GtBannerAd },
  mixins: [pageMixinCommon, defer()],
  props: {
    navHeaderList: {
      default: () => []
    },
    navFooterList: {
      default: () => []
    },
    siteInfo: {
      default: () => ({})
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    transitionName: {
      type: String,
      default: 'fade'
    },
    isLogin: {
      type: Boolean,
      default: false
    },
    accountInfo: {
      default: () => ({})
    },
    ossResize: {
      type: Function
    },
    adContent: {
      default: () => ({}),
      type: Object
    }
  },
  async asyncData({ store, app }) {
    // website 头尾初始化
    const Home = useHome();
    const { navHeaderList, navFooterList, siteInfo = {} } = await Home.init();

    const headers = app.context.req.headers;

    return {
      navHeaderList,
      navFooterList,
      siteInfo,
      isMobile: isMobile(headers['user-agent'])
    };
  },
  data() {
    return {
      showMobMenu: false
    };
  },
  computed: {
    includeCachePage() {
      return this.$store.state.includeCachePage;
    },
    adPageTop() {
      const { PageBannerWithPosition = {} } = this.adContent || {};
      return PageBannerWithPosition['top'] || [];
    }
  },
  methods: {
    triggerMobileMenu() {
      this.showMobMenu = !this.showMobMenu;
    }
  }
};
